import { groupedTriggers } from './groupedTriggers';
import { allActionsGrouped } from './groupedActions';

let tempArr = [];
let uniqueTriggersList = [];

const allRuleValidationCodeObjectsArray = [...allActionsGrouped, ...groupedTriggers]?.flatMap((element, key) => element.items);

uniqueTriggersList = allRuleValidationCodeObjectsArray?.filter((validationCodeobj, idx) => {
  // Removing duplicate objects if any
  let isDuplicate = tempArr?.includes(validationCodeobj?.ruleValidationCode);
  if (!isDuplicate) {
    tempArr.push(validationCodeobj?.ruleValidationCode);
    return true;
  }
  return false;
});

export const ruleValidationTriggers = [...uniqueTriggersList];
